import { fork, take, call, put } from 'redux-saga/effects';

import types from './types';
import { postAPIWithoutModule, apiDirect } from '../../api/generic';
import { fetchCommentDataResp, postCommentDataResp, postLikeDisLikeDataResp, postLikeDisLikeProductResp } from './actions';

export function* doPostCommentData() {
    while (true) {
        const { payload } = yield take(types.POST_COMMENT)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(postCommentDataResp(response));
    }
}

export function* doPostLikeDisLikeCommentData() {
    while (true) {
        const { payload } = yield take(types.POST_DISLIKE_LIKE_COMMENT)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(postLikeDisLikeDataResp(response));
    }
}

export function* doFetchCommentData() {
    while (true) {
        const { payload } = yield take(types.FETCH_COMMENT)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(fetchCommentDataResp(response));
    }
}

export function* doPostLikeDisLikeProduct() {
    while (true) {
        const { payload } = yield take(types.LIKE_DISLIKE_PRODUCT)
        const response = yield call(apiDirect, payload)
        yield put(postLikeDisLikeProductResp(response));
    }
}

function* discuss() {
    yield fork(doPostCommentData)
    yield fork(doPostLikeDisLikeCommentData)
    yield fork(doFetchCommentData)
    yield fork(doPostLikeDisLikeProduct)
}

export default discuss